import qs from 'qs';
import axios from "../";
const prefix = "admin/permisos";

export const getPermisos = async (id) => {
  try {
    const endpoint = id ? `${id}` : "";
    const response = await axios.get(`/${prefix}/${endpoint}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPermisos = async (params) => {
  try {
    const _params = qs.stringify(params, { arrayFormat: 'brackets' });

    const response = await axios.post(`/${prefix}/nuevo-permiso`, _params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePermiso = async (id, params) => {
  try {
    const _params = qs.stringify(params, { arrayFormat: 'brackets' });

    const response = await axios.put(`/${prefix}/${id}`, _params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletePermiso = async (id) => {
  try {
    const response = await axios.delete(`/${prefix}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};